import { AbstractPmsApiService } from "./abstract.service";
import { RoomNumber } from "../models";

/**
 * @class ShomoosRoomsMappingPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ShomoosRoomsMapping>}
 */
export class ShomoosRoomsMappingPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/shomoos-rooms-mapping(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {RoomNumber}
     * @protected
     */
    newModel(attributes, ...params) {

        return new RoomNumber(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<RoomNumber>>}
     */
    get(params = {}, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {RoomNumber} room
     * @param {Property} property
     * @returns {Promise.<boolean>}
     */
    create(room, property) {

        const url = this.url({
            propertyId: property.id,
            id: room.id
        });

        return this.http
            .post(url, room, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {RoomNumber} room
     * @param {Property} property
     * @returns {Promise.<boolean>}
     */
    update(room, property) {

        const url = this.url({
            propertyId: property.id,
            id: room.id
        });

        return this.http
            .put(url, room, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {RoomNumber} room
     * @param {Array} params
     * @returns {Promise.<boolean>}
     */
    delete(room, params) {

        const url = this.url({
            propertyId: params[0].id,
            id: room.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @returns {Promise.<Object>}
     */
    shomoosRooms(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url + '/shomoos-rooms', {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {RoomNumber} room
     * @param {Property} property
     * @returns {Promise.<boolean>}
     */
    sync(room, property) {

        const url = this.url({
            propertyId: property.id,
            id: room.id
        });

        return this.http
            .get(url + '/sync', {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/shomoos-rooms-mapping.service.js